var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    fill: "url(#pattern0_819_10172)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_819_10172",
    patternContentUnits: "objectBoundingBox",
    width: 0.0694444,
    height: 0.0694444
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_819_10172",
    transform: "scale(0.00694444)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_819_10172",
    width: 10,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAABtJREFUGBljYCACTJ8+/T9BZaOKGKgXBMDQBgAiVBupw3yftQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBg);
export default __webpack_public_path__ + "static/media/empty-bg.92820b3e4da24bff7eb5923d76a21aee.svg";
export { ForwardRef as ReactComponent };